import axiosClient from "./axiosClient";


export const createUnit = async (propertyId, data) => {
  const response = await axiosClient.post(
    `/properties/${propertyId}/units/create/`,
    data
  );
  return response.data;
};

/** Fetch full details for a specific unit (including insurance, utilities, and assessments) */
export const getUnitDetails = async (unitId) => {
  const response = await axiosClient.get(`/units/${unitId}/details/`);
  return response.data;
};

//Fetch all assessment types (used across units and properties)
export const getAssessmentTypes = async () => {
  const response = await axiosClient.get("/assessment-types/");
  return response.data;
};

export const getUnitsByProperty = async (propertyId, params) => {
  const response = await axiosClient.get(`/properties/${propertyId}/units/`, {
    params,
  });
  return response.data;
};

export const getUnitNeighbours = async (unitId) => {
  const response = await axiosClient.get(`/units/${unitId}/neighbours/`);
  return response.data;
};

export const getUnitsEmailLink = async (propertyId) => {
  const response = await axiosClient.get(
    `/properties/${propertyId}/units/email/`
  );
  return response.data;
};

export const getGroupUnitsEmailLink = async (propertyId, groupId) => {
  const response = await axiosClient.get(
    `/properties/${propertyId}/unit-groups/${groupId}/email/`
  );
  return response.data;
};


export const getPropertyById = async (propertyId) => {
  const response = await axiosClient.get(`/properties/${propertyId}/`);
  return response.data;
};

export const getAllUnits = async () => {
    const res = await axiosClient.get("/units/");
    return res.data;
  };

export const updateUnit = async (unitId, data) => {
  const response = await axiosClient.put(`/units/${unitId}/`, data);
  return response.data;
};

export const deleteUnit = async (unitId) => {
  const response = await axiosClient.delete(`/units/${unitId}/`);
  return response.data;
};

export const getUnitOwnerships = async (unitId, page = 1, pageSize = 10) => {
  const response = await axiosClient.get(`/units/${unitId}/ownerships/`, {
    params: { page, page_size: pageSize },
  });
  return response.data;
};

export const getUnitTransfers = (params) =>
  axiosClient.get("/unit-transfers/", { params });

export const changeUnitOwner = async (unitId, data) => {
  const response = await axiosClient.post(`/units/${unitId}/ownerships/`, data);
  return response.data;
};

export const updateUnitOwnership = async (unitId, ownershipId, data) => {
  const response = await axiosClient.put(`/units/${unitId}/ownerships/${ownershipId}/`, data);
  return response.data;
};

export const importUnits = async (propertyId, file) => {
  const formData = new FormData();
  formData.append("file", file);
  const response = await axiosClient.post(
    `/properties/${propertyId}/units/import/`,
    formData,
    { headers: { "Content-Type": "multipart/form-data" } }
  );
  return response.data;
};

export const previewImportUnits = async (propertyId, file) => {
  const formData = new FormData();
  formData.append("file", file);
  const response = await axiosClient.post(
    `/properties/${propertyId}/units/import/preview/`,
    formData,
    { headers: { "Content-Type": "multipart/form-data" } }
  );
  return response.data;
};

export async function downloadUnitsExcel(propertyId) {
  const response = await axiosClient.get(
    `/properties/${propertyId}/units/export/`,
    { responseType: "blob" }
  );

  const disposition = response.headers?.["content-disposition"] || "";
  const match = disposition.match(/filename="([^"]+)"/);
  const resolvedName = match?.[1] || `Units_${propertyId}.xlsx`;

  const blob = new Blob([response.data], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", resolvedName);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
}

export const getUnitGroups = async (propertyId) => {
  const response = await axiosClient.get(
    `/properties/${propertyId}/unit-groups/`
  );
  return response.data;
};

export const createUnitGroup = async (propertyId, name) => {
  const response = await axiosClient.post(
    `/properties/${propertyId}/unit-groups/`,
    { name }
  );
  return response.data;
};

export const getUnitGroupUnits = async (propertyId, groupId, params = {}) => {
  const response = await axiosClient.get(
    `/properties/${propertyId}/unit-groups/${groupId}/units/`,
    { params }
  );
  return response.data;
};

export const getUnitGroupAvailableUnits = async (propertyId, groupId, params = {}) => {
  const response = await axiosClient.get(
    `/properties/${propertyId}/unit-groups/${groupId}/units/available/`,
    { params }
  );
  return response.data;
};

export const addUnitsToGroup = async (propertyId, groupId, unitIds) => {
  const response = await axiosClient.post(
    `/properties/${propertyId}/unit-groups/${groupId}/units/add/`,
    { unit_ids: unitIds }
  );
  return response.data;
};

export const removeUnitsFromGroup = async (propertyId, groupId, unitIds) => {
  const response = await axiosClient.post(
    `/properties/${propertyId}/unit-groups/${groupId}/units/remove/`,
    { unit_ids: unitIds }
  );
  return response.data;
};

export const deleteUnitGroup = async (propertyId, groupId) => {
  const response = await axiosClient.delete(
    `/properties/${propertyId}/unit-groups/${groupId}/`
  );
  return response.data;
};
